module.exports = __webpack_public_path__ + "img/Image_Fond_Encom_Enquete.c8e6860f.jpg";